export function rotateArray(array: number[], shift: number) {
  return array.slice(shift).concat(array.slice(0, shift))
}
